module.exports = __webpack_public_path__ + "img/icon_email_bind_step_second.e579dfbc.png";